import React from "react";
import { Link } from "react-router-dom";

const Error404 = () => {
  const user = JSON.parse(localStorage.getItem("user"));

  return (
    <>
      <div className="bg-gray-100">
        <div className="min-h-screen flex flex-col justify-center items-center">
          <div className="text-4xl text-gray-700">403 - حدث خطأ</div>
          <p className="mt-4 text-gray-600">
            أوبسس!! ليس لديك صلاحية للوصول لهذه الصفحة .
          </p>

          {user.privilege === 1 ? (
            <Link
              to={`${process.env.PUBLIC_URL}/`}
              className="mt-6 px-6 py-3 bg-blue-500 hover:bg-blue-600 text-white rounded-full transition duration-300 ease-in-out transform hover:scale-105"
            >
              الصفحة الرئيسة
            </Link>
          ) : (
            <Link
              to={`${process.env.PUBLIC_URL}/orders`}
              className="mt-6 px-6 py-3 bg-blue-500 hover:bg-blue-600 text-white rounded-full transition duration-300 ease-in-out transform hover:scale-105"
            >
              صفحة الطلبات
            </Link>
          )}
        </div>
      </div>
    </>
  );
};

export default Error404;
